import React from 'react'
import { ListView, Icon, PullToRefresh } from 'antd-mobile'
import PropTypes from 'prop-types'
import Component, { mapStateToProps, mapDispatchToProps } from '../components/Component'
import { connect } from 'react-redux'
import Border from '../components/Border'
import style from './ApproveList.module.less'
import Row from '../components/ApproveList/Row'
class MyApproveList extends Component {
  constructor (props) {
    super(props)

    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => {
        return true
      }
    })

    this.state = {
      dataSource,
      isLoading: false,
      refreshing: false,
      height: document.documentElement.clientHeight * 3 / 4,
      multiSelecting: false,
      total: 0,
      pagination: {
        current: 1,
        page_size: 20
      },
      type: '未处理'
    }
  }

  list = []
  listRef = React.createRef()
  containerRef = React.createRef()

  // 到达底部加载更多
  onEndReached () {
    const { total, pagination } = this.state
    const { current } = pagination
    if (this.list.length >= total) {
      return false
    }
    this.setState({
      isLoading: true,
      pagination: {
        ...this.state.pagination,
        current: current + 1
      }
    }, () => {
      this.getData()
    })
  }

  // 初始化列表容器高度
  initListHeight () {
    const totalHeight = this.containerRef.current.offsetHeight
    this.setState({
      height: totalHeight
    })
  }

  getData () {
    const { pagination, multiSelecting } = this.state
    const params = {
      ...pagination
    }
    const condition = [{ k: 'need_do', o: '=', v: 1 }, { k: 'title', o: 'not in', v: '结案呈批' }]
    if (this.state.type === '未处理') {
      condition.push({ k: 'complete_datetime', o: 'null' })
    } else {
      condition.push({ k: 'complete_datetime', o: 'not null' })
    }
    if (multiSelecting) {
      condition.push({ k: 'auto_action', o: 'not null' })
    }
    params.condition = JSON.stringify(condition)
    return this.$get('/api/xapc/message', { params })
      .then(res => {
        this.setState({
          refreshing: false,
          isLoading: false
        })
        if (res.status === 1) {
          let list = this.list
          list = list.concat(res.data.list.map(li => {
            li.multi = this.state.multiSelecting
            li.checked = false
            try {
              li.route = JSON.parse(li.route)
            } catch (e) {
              li.route = null
            }
            return li
          }))
          this.list = list
          this.setState({
            total: res.data.total,
            dataSource: this.state.dataSource.cloneWithRows(list)
          })
        }
      }).catch(() => {
        this.setState({
          refreshing: false,
          isLoading: false
        })
      })
  }

  // 选择行数
  selectRowHandle (d, i, r) {
    this.props.history.push(`/admin/approve-detail/${d.id}`)
  }

  onRefreshHandle () {
    this.setState({
      refreshing: true,
      pagination: {
        ...this.state.pagination,
        current: 1
      }
    }, () => {
      this.list = []
      this.getData()
    })
  }

  componentDidMount () {
    this.initListHeight()
    this.setState({
      isLoading: true
    }, () => {
      this.getData()
    })
  }

  componentDidUpdate (prev) {
    const { visible } = this.props
    if (visible && prev.visible !== visible) {
      this.initListHeight()
    }
  }

  renderRow (d, i, r, highlightRow) {
    return <Row key={r} data={d} selectRowHandle={(d, i, r) => this.selectRowHandle(d, i, r)} />
  }

  renderSeparator (d, i) {
    if (i === String(this.list.length - 1)) {
      return null
    }
    return (
      <Border key={`${d}-${i}`} top={false} left={false} right={false} radius={false}>
        <div className={style.separator} />
      </Border>
    )
  }

  renderFooter () {
    const { total, isLoading } = this.state
    if (!isLoading) {
      if (this.list.length === 0) {
        return <div className={style.footer}>暂无呈批信息</div>
      }
      if (this.list.length >= total) {
        return <div className={style.footer}>没有更多了</div>
      }
    } else {
      return (
        <div className={style.footer}>
          <span className={style['footer-text']}>加载中</span>
          <Icon type='loading' />
        </div>
      )
    }
  }

  render () {
    const pageSize = this.state.pagination.page_size
    return (
      <div id='approveList' className={style.container} ref={this.containerRef}>
        <ListView
          ref={this.listRef}
          dataSource={this.state.dataSource}
          renderRow={(d, i, r, highlightRow) => this.renderRow(d, i, r, highlightRow)}
          renderSeparator={(d, i) => this.renderSeparator(d, i)}
          style={{
            height: this.state.height,
            overflow: 'auto'
          }}
          pageSize={pageSize}
          scrollRenderAheadDistance={500}
          onEndReached={() => this.onEndReached()}
          onEndReachedThreshold={200}
          initialListSize={pageSize}
          renderFooter={() => this.renderFooter()}
          pullToRefresh={
            <PullToRefresh
              damping={60}
              indicator={this.state.down ? {} : { deactivate: '下拉刷新' }}
              refreshing={this.state.refreshing}
              onRefresh={() => this.onRefreshHandle()}
            />
          }
        />
      </div>
    )
  }
}

MyApproveList.propTypes = {
  // showDetail: PropTypes.func,
  visible: PropTypes.bool
}

MyApproveList.defaultProps = {
  showDetail: () => {},
  visible: false
}

const mapState = mapStateToProps(function (state) {
  return {
    userInfo: state.basic.userInfo
  }
})

const mapDispatch = mapDispatchToProps(function (dispatch) {
  return {

  }
})

export default connect(mapState, mapDispatch)(MyApproveList)
